<header>
  <div class="upper-header">
    <div class="header-left">
      <div>
        <a href="https://www.regione.veneto.it/" target="_blank" rel="noopener">
          <img
            src="assets/images/header-regione-veneto-logo.png"
            alt="logo della regione veneto"
          />
        </a>
        <a
          href="https://www.regione.veneto.it/vivobene"
          target="_blank"
          rel="noopener"
        >
          <img
            src="assets/images/header-vivo-bene-logo.png"
            alt="logo di vivo bene"
          />
        </a>
      </div>
      <p routerLink="/home">Vivo&nbsp;<strong>Bene&nbsp;</strong> MAP</p>
    </div>
    <div class="header-right">
      <p-menubar breakpoint="1024px" [model]="menuItems" #menubar> </p-menubar>
    </div>
    <!-- <p-iconfield [formGroup]="searchForm">
    <input
      type="text"
      pInputText
      formControlName="search"
      placeholder="Cerca nel sito..."
    />
    <p-inputicon styleClass="pi pi-search" />
  </p-iconfield> -->
    <a class="user-area" [href]="BACKOFFICE_URL" target="_blank" rel="noopener"
      >Area riservata<i class="pi pi-user"></i
    ></a>
  </div>
  @if(breadcrumbItems.length){
  <p-breadcrumb [model]="breadcrumbItems">
    <ng-template #separator> / </ng-template>
  </p-breadcrumb>
  }
</header>

<!-- drawer per il menubar in responsive -->
<p-drawer
  [(visible)]="isMenubarDrawerVisible"
  showCloseIcon="true"
  [appendTo]="menubar"
>
  @for (item of menuItems; track $index) {
  <p
    routerLink="{{ item.routerLink }}"
    class="{{ item.styleClass }}"
    (click)="isMenubarDrawerVisible = false"
  >
    {{ item.label }}
  </p>
  }
  <a [href]="BACKOFFICE_URL" target="_blank" rel="noopener"
    >Area riservata<i class="pi pi-user"></i
  ></a>
</p-drawer>
